import React from 'react'
// Components
import Title from '@/components/Title'
import TextBody from '@/components/TextBody/TextBody'

import useGuaranteeOptions from '@/hooks/useGuaranteeOptions'

import rootStyles from '../../pages/puppy/[id].module.scss'
import s from './HealthGuarantee.module.scss'

export default function HealthGuarantee({ application }) {
  const { guaranteeDuration, guaranteePeriod } = application || {}
  const { options, loading } = useGuaranteeOptions(
    guaranteeDuration,
    guaranteePeriod,
  )

  return (
    <div className={rootStyles.section}>
      <Title variant="h2">Health Guarantee</Title>
      <div className={s.guarantee_container}>
        {!loading
          ? options?.map((guarantee) => (
              <div key={guarantee.id} className={s.guarantee}>
                <img
                  src={`/icons/${guarantee.icon}`}
                  alt=" guarantee icon"
                  className={s.icon}
                />
                <div className={s.content}>
                  <TextBody weight="bold">{guarantee.title}</TextBody>
                  <TextBody>{guarantee.description}</TextBody>
                </div>
              </div>
            ))
          : null}
      </div>
    </div>
  )
}
